<div mat-dialog-content class="flex flex-col items-center justify-between py-8 px-8">
  <button class="close" (click)="onNoClick()">
    <mat-icon class="material-icons-round">close</mat-icon>
  </button>

  <header>
    <p class="titule">Bluetooth</p>
  </header>

  <ion-item lines="none" class="bluetooth-item">
    <ion-toggle [(ngModel)]="bluetoothActivo" (ionChange)="onBleToogleChange($event)" mode="ios">
      <ion-label>{{ bluetoothActivo ? 'Desactivar' : 'Activar' }}</ion-label>
    </ion-toggle>
  </ion-item>

  <button (click)="onConfirmClick()" class="btn-accion" [disabled]="!bluetoothActivo">Buscar Dispositivo</button>
</div>
